
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import {combineLatest, fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import { Asset } from '../../../../../main/modules/asset/models/asset.model';
import { DefaultPermissions } from '../../models/defaultPermissions.model';
import { PermissionsFacade } from '../../facade/permissions.facade';
import { Access } from '../../models/Acces.model';
import { DeleteAccess } from '../../models/deleteAccess.model';
import { GrantAccess } from '../../models/grantAccess.model';
import { UpdateAccessOnAsset } from '../../models/updateAccessOnAsset.model';
import { User } from '../../models/user.model';
import { DeleteAccessComponent } from '../dialogs/delete-access/delete-access.component';
import {environment} from '../../../../../../../environments/environment';

@Component({
  selector: 'morva-dashboard-permissions',
  templateUrl: './dashboard-permissions.component.html',
  styleUrls: ['../styles.scss'],
})
export class DashboardPermissionsComponent implements OnInit {
  totalPage: number;
  pageNumber: number;
  asset: Asset;
  permissionGroupType = 'Dashboard';
  addUserMode = false;
  users: User[] = [];
  newAccessUsers = [];
  defaultRoles: any[] = [];
  defaultPermissions= new DefaultPermissions().filter(this.permissionGroupType);
  selectedRole: any;
  permissionsTemp = new DefaultPermissions().filter(this.permissionGroupType);
  profileForm = new UntypedFormGroup({
    userRole: new UntypedFormControl('سفارشی', Validators.required),
    user: new UntypedFormControl('', Validators.required),
    permission: new UntypedFormControl('', Validators.required),
  });
  assetId: any;
  workspaceId: any;
  loading = false;
  subscriptions =[];
  helpURL = `${environment.api}/File/Download?path=058d03e3-9abd-409f-8ad2-4cfba8d189a2/` +
    'ApplicationFiles/b1cacb55-6d49-4a81-8b76-524fce18a976.pdf';


  constructor(
    protected dialogRef: NbDialogRef<any>,
    private dialogService: NbDialogService,
    private permissionsFacade: PermissionsFacade) {}

  @ViewChild('searchKeyUser') set inputUser(inputUser: ElementRef){
    if(inputUser) {
      fromEvent(inputUser.nativeElement,'keyup')
          .pipe(
              filter(Boolean),
              debounceTime(500),
              distinctUntilChanged(),
              tap(() => {
                const searchKey = inputUser.nativeElement.value;
                this.searchUser(searchKey);
              }),
          )
          .subscribe();
    }
  };

  ngOnInit(): void {
    this.loading = true;
    this.assetId = this.asset?.assetId;
    this.permissionsFacade.updatePageNumber(1);
    this.loadUsersAndGroups();
    this.setSubscribers();
  }

  loadUsersAndGroups() {
    this.permissionsFacade.loadUsersAndUserGroups(this.permissionGroupType, this.workspaceId, this.assetId);
  }

  setSubscribers() {
    this.permissionsFacade.getNewAccessDashboard$().subscribe((newAccessUsers: any) => {
      this.newAccessUsers = newAccessUsers;
    });

    this.subscriptions.push(this.permissionsFacade.getUsers$().
    pipe(tap((users: User[]) => this.users = users)));

    this.subscriptions.push(this.permissionsFacade.getDefaultAccess$().
    pipe(tap(defaultRoles =>this.defaultRoles = defaultRoles)));

    this.subscriptions.push(this.permissionsFacade.getTotalPages$().
    pipe(tap((totalPage: number) => this.totalPage = totalPage)));

    this.subscriptions.push(this.permissionsFacade.getPageNumber$().
    pipe(tap(pageNumber => this.pageNumber = pageNumber)));

    combineLatest(this.subscriptions).subscribe(() => this.loading = false);
  }

  changeRole(roleId: string, userIndex: number) {
    this.selectedRole = this.defaultRoles.find(role => role.id === roleId);
    const permissions =
    new DefaultPermissions().mapSpecificPermissions(this.selectedRole.permissions,this.permissionGroupType,false);
    this.permissionsFacade.updateUserPermissions(roleId, userIndex, permissions, true);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      true,
      roleId);
    const body = new UpdateAccessOnAsset(this.workspaceId, this.assetId, this.permissionGroupType, access);
    this.permissionsFacade.updateDashboard(body);
  }

  changePermission(isChecked: boolean, enName, userIndex) {
    let permissionsSelected: any =
    new Map(JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected))));
    permissionsSelected =  this.checkViewAccess(isChecked, enName, permissionsSelected);
    const permissions = this.mapPermissions(permissionsSelected);
    this.permissionsFacade.updateUserPermissions('', userIndex, permissionsSelected, false);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      false,
      permissions);
    const body = new UpdateAccessOnAsset(this.workspaceId, this.assetId, this.permissionGroupType, access);
    this.permissionsFacade.updateDashboard(body);
  }

  mapPermissions(selectedPermissions: Map<string,any>): number[] {
    const result: number[] = [];
    selectedPermissions.forEach(permission => {
      if (permission.isChecked) {
        result.push(permission.id);
      }
    });
    return result;
  }



  changePageNumber(pageNumber: number) {
    this.permissionsFacade.updatePageNumber(pageNumber);
    this.permissionsFacade.updateUsersPaginateState(this.permissionGroupType,
      this.workspaceId, this.assetId, pageNumber);
  }

  closeDialog() {
    this.dialogRef.close();
    this.permissionsFacade.updatePageNumber(1);
  }

  onAddUserClicK() {
    this.addUserMode = true;
    this.loadNewUsers();
  }

  closeAddUser() {
    this.addUserMode = false;
    this.resetProfileForm();
  }

  loadNewUsers() {
    const body: GrantAccess = {
      workspaceId: this.workspaceId,
      assetId: this.assetId,
      assetType: this.permissionGroupType,
      searchKey: '',
    };
    this.permissionsFacade.loadForNewAccessDashboardWithDebounce(body, 0);

  }

  searchUser(searchKey: string) {

    const grantAccess: GrantAccess = {
      workspaceId: this.workspaceId,
      assetId: this.assetId,
      assetType: this.permissionGroupType,
      searchKey,
    };
    this.permissionsTemp = new DefaultPermissions().filter(this.permissionGroupType);
    this.changeUserRole(undefined);
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      permission: null,
    });
    this.permissionsFacade.loadForNewAccessDashboardWithDebounce(grantAccess, 1000);

  }

  viewHandle(user: any) {
    if (user.id) {
      if (user.userType === 'Group') {
        return user.groupName;
      }
      return (user.firstName + ' ' + user.lastName);
    }
    return user;

  }

  changeUserRole($event): void {
    if($event) {
      this.profileForm.controls.userRole.enable();
    } else {
      this.profileForm.controls.userRole.disable();
    }
  }

  changeDefaultAccess(roleId: string) {
    if (this.profileForm.value.user) {
      this.permissionsTemp =new DefaultPermissions().filter(this.permissionGroupType);
      const selectRole = this.defaultRoles.find(role => role.id === roleId);
      this.permissionsTemp =
        new DefaultPermissions().mapSpecificPermissions(selectRole.permissions,this.permissionGroupType,false);
      this.profileForm.patchValue({
        permission: this.permissionsTemp,
      });
    }
  }

  changeAccess(isChecked: boolean, enName: string) {
    this.permissionsTemp = this.checkViewAccess(isChecked, enName, this.permissionsTemp);
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      permission: this.permissionsTemp,
    });
  }

  onSaveUserClick() {
    const data = this.profileForm.value;
    const access = new Access(
      data.user.id,
      data.user.userType,
      true,
      data.userRole !== 'سفارشی',
      data.userRole !== 'سفارشی' ? data.userRole : this.mapPermissions(data.permission));
    const newAccess = new UpdateAccessOnAsset(this.workspaceId, this.assetId, this.permissionGroupType, access);
    this.permissionsFacade.updateDashboard(newAccess);
    this.resetProfileForm();
    this.closeAddUser();
  }

  resetProfileForm() {
    this.permissionsTemp = new DefaultPermissions().filter(this.permissionGroupType);
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      user: '',
      permission: null,
    });
  }

  openDeleteDialog(user: User) {
    const accessType = this.permissionGroupType;
    this.dialogService.open(DeleteAccessComponent, { context: { user, accessType } }).
      onClose.subscribe((isDelete) => {
        if (isDelete) {
          const body: DeleteAccess = {
            workspaceId: this.workspaceId,
            assetId: this.assetId,
            accessId: user.id,
            accessRecipientId: user.accessRecipientId,
            assetType: this.permissionGroupType,
            userType: user.accessRecipientType,
          };
          this.permissionsFacade.deleteUserAccess(body);
        }
      });
  }

  checkViewAccess(isChecked: boolean, enName: string, permissions: any): any {
    if(enName !== 'View' && isChecked) {
      permissions.get('View').isChecked = isChecked;
      permissions.get(enName).isChecked = isChecked;
    } else if (enName !== 'View' && !isChecked) {
      permissions.get(enName).isChecked = isChecked;
    } else if (enName === 'View' && isChecked) {
      permissions.get('View').isChecked = isChecked;
    } else if (enName === 'View' && !isChecked) {
      permissions = new DefaultPermissions().filter(this.permissionGroupType);
    }
    return permissions;
  }
}
